import { render, staticRenderFns } from "./PasswordInit.vue?vue&type=template&id=ada7a006&scoped=true"
import script from "./PasswordInit.vue?vue&type=script&lang=js"
export * from "./PasswordInit.vue?vue&type=script&lang=js"
import style0 from "./PasswordInit.vue?vue&type=style&index=0&id=ada7a006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada7a006",
  null
  
)

export default component.exports